/**
 * 设备检测和路由重定向服务
 */
import { isMobile } from './mobile';
import router from '../router';

/**
 * 设备类型枚举
 */
export const DeviceType = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop'
};

/**
 * 获取当前设备类型
 * @returns {string} 设备类型，'mobile' 或 'desktop'
 */
export const getDeviceType = () => {
  return isMobile() ? DeviceType.MOBILE : DeviceType.DESKTOP;
};

/**
 * 路由映射配置
 * 定义PC端和移动端对应的路由
 */
const routeMapping = {
  // 首页
  '/': {
    [DeviceType.DESKTOP]: '/',
    [DeviceType.MOBILE]: '/mobile'
  },
  // 可以添加更多页面的映射
  '/about': {
    [DeviceType.DESKTOP]: '/about',
    [DeviceType.MOBILE]: '/mobile/about'
  },
  // 其他页面...
};

/**
 * 根据当前设备类型和路由获取应该跳转的路由
 * @param {string} currentRoute 当前路由路径
 * @param {string} deviceType 设备类型
 * @returns {string} 应该跳转的路由路径
 */
export const getMappedRoute = (currentRoute, deviceType) => {
  // 获取基础路径（不包含查询参数和哈希）
  const basePath = currentRoute.split('?')[0].split('#')[0];
  
  // 查找映射配置
  for (const path in routeMapping) {
    if (basePath === path || basePath.startsWith(`${path}/`)) {
      return routeMapping[path][deviceType];
    }
  }
  
  // 如果没有找到映射，则返回原路由
  return currentRoute;
};

/**
 * 检查当前路由是否需要重定向
 * @param {object} to 目标路由对象
 * @returns {boolean} 是否需要重定向
 */
export const needsRedirect = (to) => {
  const deviceType = getDeviceType();
  const mappedRoute = getMappedRoute(to.path, deviceType);
  
  return to.path !== mappedRoute;
};

/**
 * 执行路由重定向
 * @param {object} to 目标路由对象
 */
export const performRedirect = (to) => {
  const deviceType = getDeviceType();
  const mappedRoute = getMappedRoute(to.path, deviceType);
  
  if (to.path !== mappedRoute) {
    // 构建新的路由，保留查询参数和哈希
    const query = { ...to.query };
    const hash = to.hash;
    
    router.replace({ path: mappedRoute, query, hash });
    return true;
  }
  
  return false;
};

/**
 * 初始化设备重定向
 * 在路由守卫中使用此函数来实现自动重定向
 */
export const initDeviceRedirect = () => {
  router.beforeEach((to, from, next) => {
    if (performRedirect(to)) {
      // 已经执行了重定向，不需要继续
      return;
    }
    
    next();
  });
};